import { h } from 'preact';
import useFormStore from '../../store/useFormStore';



export default function FranchiseInfoBlock() {
  const currentUserPostalCode = useFormStore((state) => state.currentPostalCode);
  const currentFranchise = useFormStore((state) => state.currentFranchise);
  const resetAll = useFormStore((state) => state.resetAll);

  const handleReset = () => {
    if (confirm('Are you sure you want to start over? This will clear all your selections.')) {
      resetAll();
    }
  };

  return (
    <div className="franchise-info-block bg-white p-6 shadow-sm space-y-6">
      <div className="text-lg font-semibold">Service Location</div>

      {/* Postal Code */}
      <div>
        <div className="flex flex-row items-start gap-2 text-sm">
          <svg className="w-5 h-5 text-coit-red shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
          </svg>
          <div className="flex flex-row gap-2">
            <div className="text-gray-600 mb-1">Postal Code:</div>
            <div className="font-semibold text-gray-900">{currentUserPostalCode}</div>
          </div>
        </div>
      </div>

      {/* Franchise Info */}
      {currentFranchise && (
        <div className="border-t border-gray-200 pt-4 mt-4 flex flex-col gap-2">
          <div className="text-lg font-semibold">Contact Your COIT</div>


          {/* Phone */}
          {currentFranchise.phone?.telephone && (
            <div className="flex items-start gap-2">
              <svg className="w-5 h-5 text-coit-red flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
              </svg>
              <div className="text-sm">
                <a href={`tel:${currentFranchise.phone.telephone}`} className="text-coit-red hover:underline font-medium">
                  {currentFranchise.phone.telephone}
                </a>
              </div>
            </div>
          )}

          {/* Email */}
          {currentFranchise.email && (
            <div className="flex items-start gap-2">
              <svg className="w-5 h-5 text-coit-red flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
              </svg>
              <div className="text-sm">
                <a href={`mailto:${currentFranchise.email}`} className="text-coit-red hover:underline break-all">
                  {currentFranchise.email}
                </a>
              </div>
            </div>
          )}

          {/* Address */}
          {currentFranchise.address && (
            <div className="flex items-start gap-2">
              <svg className="w-5 h-5 text-coit-red flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
              </svg>
              <div className="text-sm text-gray-700">
                {currentFranchise.address.address_line1 && (
                  <div>{currentFranchise.address.address_line1}</div>
                )}
                {currentFranchise.address.address_line2 && (
                  <div>{currentFranchise.address.address_line2}</div>
                )}
                <div>
                  {currentFranchise.address.locality}, {currentFranchise.address.administrative_area} {currentFranchise.address.postal_code}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Reset Button */}
      <button
        onClick={handleReset}
        className="coit-button-outline mt-4 w-full flex items-center justify-center text-[0.8rem] text-pretty"
      >
        <svg className="w-4 h-4 mr-1 hidden md:block" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
        Change Location & Start Over
      </button>
    </div>
  )
}
